import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { TradableWallet as OldTradableWallet } from "@models/interfaces/tradable_wallet";
import {
	TradableBaseWalletAdapter,
	TradableWalletBase
} from "@modules/+new/wallets/domain/entities/abstract/tradable-wallet-base.model";
import { Injectable } from "@angular/core";
import {
	AssetWalletAddress,
	AssetWalletAddressAdapter
} from "@modules/+new/wallets/domain/entities/asset-wallet-address.model";

export interface AssetWalletBase extends TradableWalletBase {
	addresses: AssetWalletAddress[];
}

@Injectable()
export class AssetWalletBaseAdapter extends BaseAdapter<OldTradableWallet, AssetWalletBase> {
	private tradableBaseWalletAdapter: TradableBaseWalletAdapter = new TradableBaseWalletAdapter();
	private assetWalletAddressAdapter: AssetWalletAddressAdapter = new AssetWalletAddressAdapter();
	public adapt(item: OldTradableWallet): AssetWalletBase {
		return {
			...this.tradableBaseWalletAdapter.adapt(item),
			addresses: this.assetWalletAddressAdapter.adaptMany(item.getAddresses())
		};
	}
}
